import React, { useEffect, useState } from "react"
import { customToast } from "../../components/Toast"
import SendMagicLinkScreen from "../../screen/SendMagicLinkScreen"
import { exportUsersMagicLinks } from "../../core/utils/exports";
import Send from "../../core/communication"

const SendMagicLinkContainer = ({ selectedsUsers, setModalMagicLinkIsOpen, modalMagicLinkIsOpen  }) => {
  const [text, setText] = useState()
  const [saving, setSaving] = useState(false)
  const [isResponseModalOpen, setIsResponseModalOpen] = useState(false);
  const [generating, setGenerating] = useState(false)
  const [generatedLink, setGeneratedLink] = useState([])
  const [checked, setChecked] = useState([])
  const [usersFailed, setUsersFailed] = useState([]);
  const [usersReceived, setUsersReceived] = useState([]);
  const [showTemplates, setShowTemplates] = useState([])
  const [selectedUser, setSelectedUsers] = useState([])
  const [projectList, setProjectList] = useState([])
  const [activeIndex, setActiveIndex] = useState(0)
  const [groupedData, setGroupedData] = useState([])
  const [success, setSuccess] = useState(false)
  const { exportUsers, loadingExport } = exportUsersMagicLinks(generatedLink, "users_data_magic_link")

  useEffect(() => {
    if(modalMagicLinkIsOpen && selectedsUsers && selectedsUsers.length) {
      setProjectList([...new Set(selectedsUsers.map(row => row?.projectId))])
      setSelectedUsers(selectedsUsers);
    }

    return () => setProjectList([]);
  }, [selectedsUsers, modalMagicLinkIsOpen]);

  const groupStack = (array, groupSize) => {
    const grouped = [];
  
    for (let i = 0; i < array.length; i += groupSize) {
      grouped.push(array.slice(i, i + groupSize));
    }
  
    return grouped;
  }

  useEffect(() => {
    if(checked.length > 0){
      setGroupedData(groupStack(checked, 10))
    }
  }, [checked])

  useEffect(() => {
    if (activeIndex !== 0) {
      if (groupedData?.length > activeIndex) {
        generateLink()
      }

      if (groupedData?.length === activeIndex && success) {
        setGenerating(false)
        setActiveIndex(0)
        customToast("Link(s) gerado(s) com sucesso.", "success")
      }
    }
  }, [groupedData, activeIndex, success])

  const generateLink = async () => {
    if (checked.length === 0) {
      customToast(
        "Não foi possível gerar o link mágico: selecione ao menos um(a) produtor(a).",
        "error",
      )
      return
    }

    try {
      setGenerating(true)

      const response = await Send.post("/dynamic-links", {
        userIds: groupedData[activeIndex]?.map((user) => user.id) || [],
      })

      if (!response || response.status === "error") {
        throw new Error(response?.data || "Unknown error")
      }

      setGeneratedLink((prevLinks) => [...prevLinks, ...response.data])
      setSuccess(true)
      setActiveIndex((prev) => prev + 1)
    } catch (error) {
      console.error("Error generating links:", error)
      customToast("Erro ao gerar links", "error")
      setSuccess(false)
    } finally {
      setGenerating(false)
    }
  }

  const sendLink = async () => {
    setSaving(true);
    
    for await (const projectId of projectList) {
      const usersToSend = selectedsUsers.filter(row => row?.projectId === projectId);

      if(projectId && usersToSend.length) {
        await Send.post("/message", {
          templateId: "HX4c3a8b78c4cd3c89a77447ef69b8c1b7",
          message: 'Para darmos início, faremos a instalação do aplicativo por onde você irá conversar com o seu técnico. Instale o aplicativo pelo link {{1}}',
          farmers: transformUsersToSendMessage(generatedLink),
          isDynamicLink: true,
          envioEmMassa: true
        })
        .then((response) => {
          customToast(`Links enviados enviados para os usuários dos projetos: "${usersToSend[0]?.project}"`, 'success')})
        .catch((error) => {
          console.log("erro ao enviar links", error);
          customToast(`Erro ao enviar link para os usuários do projeto: "${usersToSend[0]?.project}"`, 'error');
        })
      }
    }
    setSaving(false);
  }


  const handleCloseModal = () => {
    setIsResponseModalOpen(false);
    setModalMagicLinkIsOpen(false);
    setGeneratedLink([])
    setSuccess(false)
  }

  const onCheckedChange = (check, value) => {
    if(Array.isArray(check)){
      setChecked(value === "true" && check.length === checked.length ? [] : check)
    } else {
     value === "true" ? setChecked([...checked, check]) : setChecked(checked.filter((item) => item.id != check.id))
    }
  }

  useEffect(() => {
    if(modalMagicLinkIsOpen) {
      setChecked(
        Array.isArray(selectedsUsers)
        ? selectedsUsers.map((item) => ({
            id: item?.farmerId || item?.id,
            name: item?.farmerName || item?.name,
            email: item?.farmerEmail || item?.email,
          }))
        : [],
      )
    }
  }, [modalMagicLinkIsOpen])

  const transformUsersToSendMessage = (users, noChecked = false) => {
    return users.map(item => {
      const filterUser = checked.find(row => row.id === item.farmerId || row.id === item.id)
      if(noChecked && filterUser) return item;
      else if(!noChecked) return { ...item, isChecked: filterUser };
    }).filter(user => user);
  }

  const selectTemplateToSend = () => {
    setShowTemplates(false)
  }

  return (
    <SendMagicLinkScreen {...{
      modalMagicLinkIsOpen,
      selectedUsers: transformUsersToSendMessage(selectedUser),
      handleCloseModal,
      generateLink,
      saving,
      setText,
      text,
      countMessageFailed: usersFailed.length || 0,
      countMessageSend: usersReceived.length || 0,
      isResponseModalOpen,
      usersFailed,
      usersReceived,
      onCheckedChange,
      checked,
      setShowTemplates, 
      showTemplates,
      selectTemplateToSend,
      generatedLink,
      sendLink,
      generating,
      success,
      exportUsers
    }}/>
  )
}

export default SendMagicLinkContainer
